export default __webpack_public_path__ + "static/media/what-to-do.4bbd9400.png";